module.exports = __webpack_public_path__ + "img/SSWS_Knight_sword.7f583f80.png";